export default [
  'Sehr gewöhnlich',
  'Gewöhnlich',
  'Neutral',
  'Ungewöhnlich',
  'Sehr ungewöhnlich',
]
